/**
 * 朋友两页里几项事实连成一行（“宠物 · 猫 · 最近往来 10月2日”“同地 12 次 · 当面 10 次”）：
 * 每一项是一个不折行的小块，项与项之间用“ · ”，窄屏只在这里换行，不拆成“最近 / 往来”“当 / 面”（样式见 petFriends.css .ps-friend-part__text）。
 */
export function FriendParts({ parts }: { parts: readonly string[] }) {
  return (
    <>
      {parts.map((part, index) => (
        <span key={index} className="ps-friend-part">
          {index ? " · " : null}
          <span className="ps-friend-part__text">{part}</span>
        </span>
      ))}
    </>
  );
}
